export default {"src":"/_next/static/media/husqvarna.35256d07.svg","height":50,"width":255,"blurWidth":0,"blurHeight":0};